import { type FC, lazy, Suspense } from 'react';
import { RelayEnvironmentProvider } from 'react-relay';
import { getEnvironment } from '../relayModernEnvironment.ts';

export const TradeApplicationContainerLazy: FC = () => {
    const environment = getEnvironment();

    const LazyComponent = lazy(
        () =>
            import(
                /* webpackChunkName: "TradeApplicationContainer" */ './TradeApplicationContainer.tsx'
            )
    );

    return (
        <RelayEnvironmentProvider environment={environment}>
            <Suspense fallback={null}>
                <LazyComponent />
            </Suspense>
        </RelayEnvironmentProvider>
    );
};
